import { Link } from "react-router-dom";
import Navigation from "@/components/layout/Navigation";
import Footer from "@/components/layout/Footer";

const Terms = () => {
  return (
    <div className="min-h-screen bg-background">
      <Navigation />
      <main className="py-16 md:py-24">
        <article className="container mx-auto px-4 max-w-3xl">
          <h1 className="font-display text-3xl md:text-4xl font-bold text-primary mb-2">
            Terms &amp; Conditions
          </h1>
          <p className="font-mono text-sm text-muted-foreground mb-10">
            Last updated: 20 February 2025
          </p>

          <div className="prose prose-sm md:prose-base max-w-none space-y-8 text-foreground/80 leading-relaxed text-left">
            {/* ── Intro ── */}
            <section>
              <p>
                Welcome to Rebecca Ryell Travel. By using this website you agree to these terms. If
                you don't agree, please don't use the site — no hard feelings.
              </p>
            </section>

            {/* ── About the service ── */}
            <section>
              <h2 className="font-display text-xl font-bold text-primary mt-0">About the Service</h2>
              <p>
                Rebecca Ryell Travel provides family adventure coaching, educational content, and a
                community newsletter. All services are delivered by Rebecca Ryell, a practising GP
                registered in the United Kingdom.
              </p>
            </section>

            {/* ── Medical disclaimer ── */}
            <section>
              <h2 className="font-display text-xl font-bold text-primary">Medical Information</h2>
              <p>
                Content on this site is for <strong>educational purposes only</strong> and does not
                constitute medical advice, diagnosis, or a doctor-patient relationship. Always consult
                your own healthcare provider before making medical decisions, especially when
                travelling with children.
              </p>
              <p>
                In an emergency, contact your local emergency services immediately.
              </p>
            </section>

            {/* ── Coaching services ── */}
            <section>
              <h2 className="font-display text-xl font-bold text-primary">Coaching Services</h2>
              <ul className="list-disc pl-6 space-y-1">
                <li>
                  Coaching sessions are booked and paid for in advance. Cancellations with at least 48
                  hours' notice will receive a full refund or reschedule.
                </li>
                <li>
                  Late cancellations (under 48 hours) may be charged in full at our discretion.
                </li>
                <li>
                  Sessions are confidential. We won't share what you discuss without your permission,
                  unless required by law.
                </li>
              </ul>
            </section>

            {/* ── Intellectual property ── */}
            <section>
              <h2 className="font-display text-xl font-bold text-primary">Intellectual Property</h2>
              <p>
                All content on this website — including text, images, graphics, and branding — belongs
                to Rebecca Ryell Travel unless otherwise stated. You're welcome to share links, but
                please don't copy, reproduce, or redistribute content without written permission.
              </p>
            </section>

            {/* ── User content ── */}
            <section>
              <h2 className="font-display text-xl font-bold text-primary">Your Content</h2>
              <p>
                If you submit content to us (e.g. testimonials, comments, or images), you grant us
                permission to use it on the website and social media channels. You confirm that you
                have the right to share that content and that it doesn't infringe anyone else's rights.
              </p>
            </section>

            {/* ── Third-party links ── */}
            <section>
              <h2 className="font-display text-xl font-bold text-primary">Third-Party Links</h2>
              <p>
                This site may contain links to external websites (e.g. Home Exchange, booking
                platforms). We're not responsible for the content or privacy practices of those sites.
                Use them at your own discretion.
              </p>
            </section>

            {/* ── Affiliate / employment disclosure ── */}
            <section>
              <h2 className="font-display text-xl font-bold text-primary">Affiliate &amp; Employment Disclosure</h2>
              <p>
                Rebecca works for Home Exchange and genuinely loves the service. Opinions expressed on
                this site are always her own. Where applicable, affiliate relationships or commercial
                partnerships will be clearly disclosed.
              </p>
            </section>

            {/* ── Limitation of liability ── */}
            <section>
              <h2 className="font-display text-xl font-bold text-primary">Limitation of Liability</h2>
              <p>
                We do our best to keep information accurate and up to date, but we can't guarantee
                everything is perfect at all times. Rebecca Ryell Travel is not liable for any loss or
                damage arising from your use of this website or reliance on its content. Travel always
                carries inherent risks — please do your own due diligence.
              </p>
            </section>

            {/* ── Governing law ── */}
            <section>
              <h2 className="font-display text-xl font-bold text-primary">Governing Law</h2>
              <p>
                These terms are governed by the laws of England and Wales. Any disputes will be subject
                to the exclusive jurisdiction of the courts of England and Wales.
              </p>
            </section>

            {/* ── Changes ── */}
            <section>
              <h2 className="font-display text-xl font-bold text-primary">Changes to These Terms</h2>
              <p>
                We may update these terms from time to time. Continued use of the website after changes
                means you accept the updated terms.
              </p>
            </section>

            {/* ── Contact ── */}
            <section>
              <h2 className="font-display text-xl font-bold text-primary">Contact</h2>
              <p>
                Questions about these terms? Drop us a line at{" "}
                <a href="mailto:hello@rebeccaryell.com" className="text-accent hover:underline">
                  hello@rebeccaryell.com
                </a>.
              </p>
            </section>
          </div>

          {/* Back link */}
          <div className="mt-12">
            <Link
              to="/"
              className="font-mono text-sm text-muted-foreground hover:text-primary transition-colors"
            >
              ← Back to Home
            </Link>
          </div>
        </article>
      </main>
      <Footer />
    </div>
  );
};

export default Terms;
